module.exports = __webpack_public_path__ + "static/media/br-am.30e313ea.svg";